const INTERNAL_KEY = "mmp_internal";

export const isInternal = () => localStorage.getItem(INTERNAL_KEY) === "1";

export const markInternal = () => {
  localStorage.setItem(INTERNAL_KEY, "1");
  window.posthog?.opt_out_capturing?.();
};

export const track = (event, props) => {
  if (isInternal()) return;
  window.posthog?.capture?.(event, props);
};

export const identify = (user) => {
  if (isInternal()) return;
  window.posthog?.identify?.(user.id, { restaurant_name: user.restaurant?.name, signed_up_at: user.created_at });
};

export const resetAnalytics = () => window.posthog?.reset?.();
